/**
 * fetch() to Rails with form-encoded body and JSON responses, matching typical
 * UJS-style headers (CSRF, X-Requested-With, Accept: application/json).
 */
const ACCEPT_JSON = {
  Accept: 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
} as const

const URLENCODED = 'application/x-www-form-urlencoded; charset=UTF-8'

export function railsFormJsonHeaders(
  csrfToken: string
): Record<string, string> {
  return {
    'X-CSRF-Token': csrfToken,
    ...ACCEPT_JSON,
  }
}

type RailsFormMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'

export function railsFormFetch(
  input: string,
  options: {
    method: RailsFormMethod
    body?: URLSearchParams | string | null
    csrfToken: string
    signal?: AbortSignal
  }
): Promise<Response> {
  const { method, body, csrfToken, signal } = options
  const hasBodyContent = body !== undefined && body !== null && method !== 'GET'

  return fetch(input, {
    method,
    body: hasBodyContent ? body : undefined,
    credentials: 'same-origin',
    signal,
    headers: {
      ...railsFormJsonHeaders(csrfToken),
      ...(hasBodyContent ? { 'Content-Type': URLENCODED } : {}),
    },
  })
}
